import React from 'react';
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import {InferPropTypes} from 'commons/types/Types';
import {Utils} from 'commons';

EfeErrorMsg.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
        .isRequired,
};

function EfeErrorMsg(props: InferPropTypes<typeof EfeErrorMsg.propTypes>) {
    const {message} = props;

    return (
        <div className='efe-error-msg'>
            <Typography variant='caption' display='block' gutterBottom color='error'>
                {Array.isArray(message) ? (
                    <ul key={`efe-error-${Utils.functions.Generate.uniqueID()}`}>
                        {message.map((msj: string | null | undefined, index: number) => (
                            <li key={index}>{msj}</li>
                        ))}
                    </ul>
                ) : null}
                {typeof message === 'string' ? message : null}
            </Typography>
        </div>
    );
}

export default EfeErrorMsg;
